import {
  Chip,
  ChipColor,
  CircleQuestionIcon,
  cn,
  SparklesIcon,
  Typography,
  TypographyColor,
} from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

interface props {
  customClassName: string;
  chipColor: ChipColor;
  iconClass?: string;
  titleColor?: TypographyColor;
  descColor: TypographyColor;
  onClick?: () => void;
}

function LearningAdvisorTile({
  customClassName,
  titleColor,
  descColor,
  onClick,
  chipColor,
  iconClass,
}: props) {
  return (
    <div className="w-1/2 items-center flex flex-col" onClick={onClick}>
      <div
        className={cn(
          'py-8 px-5 border border-dashed flex-col flex items-center rounded-md',
          customClassName,
        )}
      >
        <div className="flex justify-end w-full">
          <CircleQuestionIcon color="gray" size="md" />
        </div>
        <SparklesIcon color="teal" size="2xl" className={cn('mb-5', iconClass)} />
        <Typography className="mb-2" variant="bodyMedium" fontWeight="semibold" color={titleColor}>
          <T kind="Chat with our AI Learning Advisor" />
        </Typography>
        <Typography variant="bodySmall" color={descColor} className="leading-3 self-stretch">
          <T kind="Let EXO - your AI advisor - do the heavy lifting by tailoring a collection to your objectives. Great for admins seeking recommendations and guidance while building." />
        </Typography>
      </div>
      <Chip
        className="w-fit mt-4 py-1 px-3 gap-2.5 text-xs font-medium"
        radius="full"
        color="light-green"
        variant="outlined"
      >
        <T kind="Create in minutes" />
      </Chip>
    </div>
  );
}
export default observer(LearningAdvisorTile);
